<template>
  <refonte-filters-tabs-item
    label="Inscriptions"
    v-bind:selected="selectedTab === INSCRIPTIONS_ACTIVES"
    v-bind:on_click="
      () => {
        handleClick(INSCRIPTIONS_ACTIVES);
      }
    " />
  <refonte-filters-tabs-item
    label="Inscriptions annulées/transférées"
    v-bind:selected="selectedTab === INSCRIPTIONS_ANNULEES_TRANSFEREES"
    v-bind:on_click="
      () => {
        handleClick(INSCRIPTIONS_ANNULEES_TRANSFEREES);
      }
    " />
</template>

<script setup lang="ts">
  import RefonteFiltersTabsItem from '@/components/refonte/filters/refonte-filters-tabs-item.vue';
  import { computed } from 'vue';
  import {
    INSCRIPTIONS_FILTERS_CONFIGURATION,
    useInscriptionFilterStore,
    INSCRIPTIONS_ACTIVES,
    INSCRIPTIONS_ANNULEES_TRANSFEREES
  } from '@/stores/inscriptions';
  import { InscriptionsFilterType } from '@/types/gestion/inscriptions-filters-types';

  const inscriptionsFilterStore = useInscriptionFilterStore();
  const selectedTab = computed(
    () => inscriptionsFilterStore?.filters?.inscriptions ?? INSCRIPTIONS_ACTIVES
  );
  const updateFilter = (
    name: string,
    value: number | string | undefined | Date | boolean
  ) => {
    inscriptionsFilterStore.resetFilters();

    inscriptionsFilterStore.setFilter(name, value);
  };
  function handleClick(tab: InscriptionsFilterType) {
    updateFilter(INSCRIPTIONS_FILTERS_CONFIGURATION.inscriptions.name, tab);
  }
</script>

<style lang="scss" scoped></style>
